import { CardSearch, PageBodyHeader, Table } from "../../component";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { fetchOrderTrackerMonthlyTarget } from "../../action/generalFunc";
import { generalObj, UrlTypes } from "../../constant/object_types";

const formatMonth = (month:string) => {
    if (!month) return "-";
    const [year, monthNumber] = month.split("-");
    const monthDate = new Date(Number(year), Number(monthNumber) - 1);
    return Number.isNaN(monthDate.getTime()) ? month : `${monthDate.toLocaleString("en-US", {month:"short"})} ${year}`;
};

const formatNumber = (value:number | string | undefined) => value === undefined || value === null ? "-" : Number(value).toLocaleString("en-US", {maximumFractionDigits: 2});

const normalizeMonth = (month:string) => month.replace("_", "-");

const getCurrentMonth = () => {
    const currentDate = new Date();
    return `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`;
};

const AdminOrderMonthlyTargetList = () => {
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState<string>("");
    const [monthlyTargets, setMonthlyTargets] = useState<generalObj[]>([]);

    const {setModalLoading}:{setModalLoading:Function} = useOutletContext();
    const account = useSelector((state:RootState) => state.account);
     
    useEffect(() => {
        if (!account || !account.isAuthenticated) return;
        const loadMonthlyTargets = async () => {
            setModalLoading(true);
            const result = await fetchOrderTrackerMonthlyTarget(account.token);
            const targets = Array.isArray(result) ? result : [];
            const currentMonth = getCurrentMonth();
            const hasCurrentMonth = targets.some((item) => normalizeMonth(String(item.date || "")) === currentMonth);
            setMonthlyTargets(hasCurrentMonth ? targets : [{date: currentMonth, target: 0, achieved: 0}, ...targets]);
            setModalLoading(false);
        };

        loadMonthlyTargets();
    }, [account, setModalLoading]);

    const onSearch = (val:string) => {
        setSearchText(val);
    }

    return (
        <>
            <PageBodyHeader title="Order Monthly Target List" desc="Check list of monthly order targets for stores" />

            <Table table_head={["Months", "Target", "Achieved", "Action"]} th_class="white" color={"#1159AB"} thColor={"#1159AB"}
            tableSearch={<CardSearch value={searchText} onTextChange={(evt) => onSearch(evt)} />}
            headerStyle={{marginBottom: "44px"}}
            >
                <>
                    {monthlyTargets.filter((item) => `${item.date} ${item.target} ${item.achieved}`.toLowerCase().includes(searchText.toLowerCase())).map((item, index) => (
                        <tr key={item.date || index}>
                            <td>{formatMonth(item.date)}</td>
                            <td>{formatNumber(item.target)}</td>
                            <td>{formatNumber(item.achieved)}</td>
                            <td><button onClick={() => navigate(`${UrlTypes.ADMIN_ORDER_TARGET_SUPERVISOR}${item.date.replace("-", "_")}/`)} className={`status__container completed`} style={{width:"60px", padding:"5px"}}>View</button></td>
                        </tr>
                    ))}
                </>
            </Table>
        </>
    )
}

export default AdminOrderMonthlyTargetList;